import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const controlStyles = css`
  border: 1px solid ${theme.colors.neutral20};
  border-radius: ${theme.borderRadius.small};
  padding: ${theme.spacing(0.75)} ${theme.spacing(1)};
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  cursor: pointer;
`;
